import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, LibraryBig, Bookmark, Sparkles, Info } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, end: true, testid: "nav-home" },
  { to: "/explore", label: "Explore", icon: Compass, testid: "nav-explore" },
  { to: "/collections", label: "Collections", icon: LibraryBig, testid: "nav-collections" },
  { to: "/saved", label: "Saved", icon: Bookmark, testid: "nav-saved" },
  { to: "/about", label: "About", icon: Info, testid: "nav-about" },
];

export default function Sidebar() {
  return (
    <aside className="hidden lg:flex flex-col w-[260px] shrink-0 border-r border-white/5 bg-[#110d0a]/60 backdrop-blur-sm">
      <div className="px-8 pt-10 pb-8">
        <div className="flex items-baseline gap-2">
          <h1 className="font-display text-[26px] leading-none text-paper" data-testid="brand-title">Majalisul Ilm</h1>
          <span className="font-arabic text-gold text-lg leading-none">مجالس العلم</span>
        </div>
        <p className="label-caps mt-3">Circles of Knowledge</p>
        <p className="mt-4 text-[12.5px] text-white/55 italic leading-relaxed font-display" data-testid="sidebar-theme">
          &ldquo;Understanding Islam by studying the classical works of
          As-Salaf As-Saleh from the scholars of present.&rdquo;
        </p>
      </div>

      <nav className="px-4 flex-1">
        {items.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-4 py-3 rounded-md text-[15px] mb-1 transition-all ${
                isActive
                  ? "text-emerald-soft bg-white/[0.03]"
                  : "text-white/70 hover:text-paper hover:bg-white/[0.03]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
                <span>{label}</span>
                {isActive && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-emerald-soft animate-pulse-glow" />}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="px-6 pb-10">
        <div className="hair-divider mb-6" />
        <div className="glass-card rounded-lg p-5">
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className="w-4 h-4 text-gold" />
            <span className="label-caps text-gold/90">Scholar mode</span>
          </div>
          <p className="text-sm text-white/70 leading-relaxed mb-4">
            Continuous listening with a persistent player, queue, and saved lectures.
          </p>
          <button className="btn-ghost-gold text-sm w-full" data-testid="sidebar-cta">Begin Listening</button>
        </div>
      </div>
    </aside>
  );
}
